import * as Sentry from '@sentry/react';

const dsnNode = document.getElementById('sentryDSN');
const envNode = document.getElementById('sentryEnv');

if (dsnNode && envNode) {
  try {
    Sentry.init({
      dsn: dsnNode.value,
      environment: envNode.value,
      release: window.RELEASE,
    });
  } catch {
    console.warn('Sentry failed to initialised. invalid DSN: ' + dsnNode.value + '?');
  }
} else {
  //Do not complain while running unittests, so our unittests logs are not completly full

  if (typeof process === 'undefined' || typeof process.env.JEST_WORKER_ID === 'undefined') {
    console.warn('Sentry disabled');
  }
}

export {Sentry};

export const initSentryWithUser = (user) => {
  Sentry.setUser({
    role: user.role,
    id: user.id || 'n/a',
    account: user.accountId || 'n/a',
    email: user.email || 'n/a',
    superUser: user.superUser || 'n/a',
  });

  Sentry.setTag('account', user.accountId || 'n/a');
};
